import Vue from "vue";
// 针对 input做的限制，只能输入正整数
Vue.directive("Int", {
  bind(input: any) {
    input.onkeyup = (e) => {
      if (input.value.length === 1) {
        input.value = input.value.replace(/[^0-9]/g, "");
      } else {
        input.value = input.value.replace(/[^\d]/g, "");
      }
      trigger(input, "input");
    };
    input.onblur = (e) => {
      if (input.value.length === 1) {
        input.value = input.value.replace(/[^0-9]/g, "");
      } else {
        input.value = input.value.replace(/[^\d]/g, "");
      }
      trigger(input, "input");
    };
  },
});
const trigger = (el, type) => {
  const e = document.createEvent("HTMLEvents");
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
};
